import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import APIKit from "../../config/APIKit";

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await APIKit.get(`/category/list`);
      return response.data;
    } catch (error) {
      if (error && typeof error === "object" && error.response) {
        // If 422 or "expired" is returned, pass it back for detection
        return rejectWithValue({
          status: error.response.status,
          data: error.response.data,
          message: error.response.data?.message || "Categories fetch failed"
        });
      }
      return rejectWithValue("Categories get failed");
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categories: null,
    status: "idle",
    subscriptionExpired: false,
    error: null ,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Robust check for subscription expired message in success payload
        const payloadStr = action.payload ? JSON.stringify(action.payload).toLowerCase() : "";
        const isExpired = payloadStr.includes("subscription has expired") || 
                         payloadStr.includes("subscription expired");

        if (isExpired) {
          state.subscriptionExpired = true;
          state.categories = [];
        } else {
          state.subscriptionExpired = false;
          state.categories = action.payload.data || action.payload;
        }
        state.error = null;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = "failed";
        
        // Comprehensive check for "expired" keyword and status 422
        const payloadStr = action.payload ? JSON.stringify(action.payload).toLowerCase() : "";
        const errorStr = action.error?.message ? action.error.message.toLowerCase() : "";
        const combinedMsg = (payloadStr + " " + errorStr);
        
        // If 422 status was explicitly passed or the message suggests expiration
        if (
          action.payload?.status === 422 || 
          combinedMsg.includes("expired") || 
          combinedMsg.includes("subscription")
        ) {
          state.subscriptionExpired = true;
        }

        state.error =
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message || action.payload?.data?.message || "categories get failed";
      });
  },
});

export default categoriesSlice.reducer;
